import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaClipboardCheck,
  FaTruck,
  FaHourglassHalf,
  FaBoxOpen,
  FaCalendarAlt,
} from "react-icons/fa";

import "bootstrap/dist/css/bootstrap.min.css";
import "./ShipmentTimeline.css";

export default function ShipmentTimeline() {
  const steps = [
    {
      title: "Registrierung",
      desc: "Sendung im Logistikzentrum registriert",
      location: "Berlin",
      date: "29 April 2025",
      time: "14:04",
      icon: <FaCalendarAlt size={24} />,
      active: true,
    },
    {
      title: "Versand",
      desc: "Sendung im Logistikzentrum eingegangen",
      location: "Berlin",
      date: "30 April 2025",
      time: "19:36",
      icon: <FaBoxOpen size={24} />,
      active: true,
    },
    {
      title: "Transport & Verarbeitung",
      desc: "Sendung im Sortierzentrum angekommen",
      location: "Leipzig",
      date: "01 Mai 2025",
      time: "11:43",
      icon: <FaHourglassHalf size={24} />,
      active: true,
    },
    {
      title: "Zustellung",
      desc: "Sendung mit Zusteller unterwegs",
      location: "Dresden",
      date: "01 Mai 2025",
      time: "12:48",
      icon: <FaTruck size={24} />,
      active: false,
      current: true, 
    },
    {
      title: "Bestellung abgeschlossen",
      desc: "Sendung erfolgreich zugestellt",
      location: "",
      date: "",
      time: "",
      icon: <FaClipboardCheck size={24} />,
      active: false,
    },
  ];

  return (
    <Container className=" shipment-container d-flex justify-content-center flex-column p-5">
      {" "}
      <h5 className="text-center fw-bold mb-5">
        Sendungsdetails: <span className="text-success">EN-2025-123456</span>
      </h5>
      {/* Desktop / Large Screens */}
      <Row className="d-none d-md-flex justify-content-center text-center">
        {steps.map((step, index) => {
          const isActive = step.active;
          const isCurrent = step.current;
          const isNextActive = steps[index + 1]?.active;

          return (
            <Col
              key={index}
              md={2}
              className="d-flex flex-column align-items-center mb-4 position-relative timeline-step"
            >
              <div
                className={`timeline-circle ${
                  isCurrent ? "current" : isActive ? "active" : "inactive"
                }`}
              >
                {step.icon}

                {index < steps.length - 1 && (
                  <div
                    className={`timeline-connector-horizontal ${
                      (isActive || isCurrent) && isNextActive
                        ? "connector-active"
                        : ""
                    }`}
                  ></div>
                )}
              </div>

              <h6
                className={`fw-bold ${
                  isCurrent
                    ? "text-current"
                    : isActive
                    ? "text-active"
                    : "text-inactive"
                }`}
              >
                {step.title}
              </h6>

              <p className="mb-1 small">{step.desc}</p>
              {step.location && (
                <p className="mb-1 text-muted small">{step.location}</p>
              )}
              {step.date && (
                <p className="mb-1 text-muted small">
                  {step.date} <br /> {step.time}
                </p>
              )}
            </Col>
          );
        })}
      </Row>
      {/* Mobile / Small Screens */}
      <div className="d-md-none">
        {steps.map((step, index) => {
          const isActive = step.active;
          const isCurrent = step.current;
          const isNextActive = steps[index + 1]?.active;

          return (
            <div
              key={index}
              className="d-flex align-items-start position-relative timeline-row"
            >
              {/* Circle */}
              <div
                className={`timeline-circle ${
                  isCurrent ? "current" : isActive ? "active" : "inactive"
                }`}
              >
                {step.icon}
                {index < steps.length - 1 && (
                  <div
                    className={`timeline-connector-vertical ${
                      (isActive || isCurrent) && isNextActive
                        ? "connector-active"
                        : ""
                    }`}
                  ></div>
                )}
              </div>

              {/* Texts */}
              <div className="ms-3">
                <h6
                  className={`fw-bold ${
                    isCurrent
                      ? "text-current"
                      : isActive
                      ? "text-active"
                      : "text-inactive"
                  }`}
                >
                  {step.title}
                </h6>
                <p className="mb-1 small">{step.desc}</p>
                {step.location && (
                  <p className="mb-1 text-muted small">{step.location}</p>
                )}
                {step.date && (
                  <p className="mb-1 text-muted small">
                    {step.date} <br /> {step.time}
                  </p>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </Container>
  );
}
